import * as types from '../mutation-types'
import * as apis from '../../apis'

let processingLoading = Promise.resolve(true);
let historyLoading = Promise.resolve(true);

const state = {
    processing: [],
    processingMeta: {
        current_page: 0,
        total: 0,
    },
    history: [],
    historyMeta: {
        current_page: 0,
        total: 0,
    }
};

const getters = {
    processing: state => state.processing,
    processingMeta: state => state.processingMeta,
    history: state => state.history,
    historyMeta: state => state.historyMeta,
    orderById: state => (id) => state.processing.concat(state.history).find(order => order.id == id),
};

const actions = {
    getOrder({ commit }, payload) {
        let orderId = payload;
        let data = null;
        if (typeof payload === 'object') {
            orderId = payload.id;
            data = payload.data;
        }

        return apis.getOrder(orderId, data).then(res => {
            if (res.data.status !== 'preparing') {
                commit(types.SET_ORDER, res.data);
            }

            return res;
        });
    },
    getProcessingOrders({ commit }, payload) {
        payload.status = 'processing';

        return apis.getOrders(payload).then(res => {
            commit(types.SET_PROCESSING_ORDERS, res.data);

            return res;
        });
    },
    loadMoreProcessingOrders({ commit, state }, payload) {
        return processingLoading.then(() => {
            payload.status = 'processing';
            payload.page = state.processingMeta.current_page + 1;

            return apis.getOrders(payload).then(res => {
                commit(types.LOAD_MORE_PROCESSING, res.data);

                return res;
            });
        });
    },
    getHistoryOrders({ commit }, payload) {
        payload.status = 'history';

        return apis.getOrders(payload).then(res => {
            commit(types.SET_HISTORY_ORDERS, res.data);

            return res;
        });
    },
    loadMoreHistoryOrders({ commit }, payload) {
        return historyLoading.then(() => {
            payload.status = 'history';
            payload.page = state.historyMeta.current_page + 1;

            return apis.getOrders(payload).then(res => {
                commit(types.LOAD_MORE_HISTORY, res.data);

                return res;
            });
        });
    },
    putOrder({ commit }, payload) {
        return apis.putOrder(payload).then(res => {
            commit(types.SET_ORDER, res.data);

            return res;
        });
    },
    restartOrder({ commit, rootState }, orderId) {
        let payload = {
            'id': orderId,
        };

        if (rootState.user.isLineMini && liff.isInClient()) {
            payload.data = {
                'mini_token': liff.getAccessToken(),
            }
        }

        return apis.restartOrder(payload).then(res => {
            commit(types.SET_ORDER, res.data);

            return res;
        })
    },
    revokeOrder({ commit }, payload) {
        return apis.revokeOrder(payload).then(res => {
            commit(types.SET_ORDER, res.data);

            return res;
        });
    },
    cancelOrder({ commit }, payload) {
        return apis.cancelOrder(payload).then(res => {
            commit(types.SET_ORDER, res.data);

            return res;
        });
    },
    deleteOrder({ commit }, id) {
        return apis.deleteOrder(id).then(res => {
            commit(types.DELETE_ORDER);

            return res;
        })
    },
    scoreOrder({ commit }, payload) {
        return apis.scoreOrder(payload).then(res => {
            commit(types.SET_ORDER, res.data);

            return res;
        })
    },
    extendPairing({ commit }, id) {
        return apis.extendPairing(id).then(res => {
            commit(types.SET_ORDER, res.data);

            return res;
        })
    }
};

const mutations = {
    [types.SET_PROCESSING_ORDERS](state, orders) {
        state.processing = orders.data;
        state.processingMeta = orders.meta;
    },
    [types.SET_HISTORY_ORDERS](state, orders) {
        state.history = orders.data;
        state.historyMeta = orders.meta;
    },
    [types.SET_ORDER](state, order) {
        let index = state.processing.findIndex(o => o.id === order.id);
        let historyIndex = state.history.findIndex(o => o.id === order.id);

        if (['任務已經完成', '任務已經取消'].indexOf(order.status_text) >= 0) {
            if(index >= 0) state.processing.splice(index, 1);
            if (historyIndex >= 0) {
                state.history.splice(historyIndex, 1, order);
            } else {
                state.history.splice(0, 0, order);
            }
        } else if (index >= 0) {
            state.processing.splice(index, 1, order);
        } else {
            state.processing.push(order);
        }
    },
    [types.DELETE_ORDER](state, id) {
        const historyIndex = state.history.findIndex(o => o.id === id);
        if (historyIndex >= 0) {
            state.history.splice(historyIndex, 1)
        }
    },
    [types.LOAD_MORE_PROCESSING](state, orders) {
        state.processingMeta = orders.meta;
        state.processing = state.processing.concat(orders.data).filter((order, index, orders) => {
            return orders.findIndex(o => o.id === order.id) === index;
        });
    },
    [types.LOAD_MORE_HISTORY](state, orders) {
        state.historyMeta = orders.meta;
        state.history = state.history.concat(orders.data).filter((order, index, orders) => {
            return orders.findIndex(o => o.id === order.id) === index;
        });
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
};
